import React from 'react';
import { ReactComponent as SunSvg } from '../../../../resources/images/sun.svg';
import Icon from '@ant-design/icons';
import { Tooltip } from 'antd';

const LIGHTING_MODE = {
    0: "перед инициализацией автомата управления светом",
    1: "ночь",
    2: "рассвет",
    3: "день",
    4: "закат",
    5: "принудительный переход в ночь",
    6: "принудительный переход в день"
}

export const LightingModeButton = ({ handleClick, lightState, lightStateTitle, lightIsOn }) => {
    const getIsLightning = (lightMode) => [2, 3, 4, 6].includes(lightMode);
    const [isLightning, setIsLightning] = React.useState(getIsLightning(lightState));
    
    React.useEffect(() => {
        setIsLightning(getIsLightning(lightState) && lightIsOn)
    }, [lightState, lightIsOn])

    function onClick() {
        if(lightIsOn) {
            handleClick();
            setIsLightning(isLightning => !isLightning);
        }
    }

    return <div
        style={{
            color: isLightning ? '#FFFF00' : '#7F7F7F',
            fontSize: '55px',
            cursor: 'pointer'
        }}
        onClick={onClick}
        className='widget-button'
    >
        <Tooltip
            placement="topLeft"
            title={lightState ? lightStateTitle?.title + ` «${LIGHTING_MODE[lightState]}»` : lightStateTitle?.noneStateTitle}
        >
            <Icon component={SunSvg} />
        </Tooltip>
    </div>
}